// src/config/navigation.js
const menuItems = [
  { name: "Main", path: "/" },
  { name: "Bio", path: "/bio" },
  { name: "Performance Calendar", path: "/performance-calendar" },
  { name: "Photos", path: "/photos" },
  { name: "Discography", path: "/discography" },
  { name: "Sheet Music", path: "/sheet-music" },
  { name: "Videos", path: "/videos" },
  { name: "Contact", path: "/contact" },
  // { name: "Programming", path: "/programming" },
];

export default menuItems;
